<template>
  <CustomModal
    :is-modal-open="isOpen"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-[100vw] tw:md:w-[456px] tw:md:max-w-[calc(100vw-32px)] tw:h-[100vh] tw:md:h-auto tw:md:rounded-xl tw:rounded-none'"
    @toggleModal="requestClose">
    <template #modalHeader>
      <h2 class="tw:text-xl">{{ $t('description_changes_unsaved_header') }}</h2>
    </template>

    <p class="tw:w-full">
      {{ $t('description_changes_unsaved_info') }}
    </p>

    <template #modalFooter>
      <div class="tw:flex tw:w-full tw:justify-end tw:gap-4">
        <GhostButton size="big" class="tw:px-8 tw:py-2.5" :disabled="isSaving" @click="emit('discard')">
          {{ $t('description_changes_discard') }}
        </GhostButton>
        <MainButton size="big" class="tw:px-8 tw:py-2.5" :disabled="isSaving" @click="emit('save')">
          <span v-if="isSaving">
            <SmallDotLoader color="#fff" />
          </span>
          <span v-else>{{ $t('description_changes_save_cta') }}</span>
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import CustomModal from '@/components/base/CustomModal.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'discard', 'save'])

const requestClose = () => {
  if (props.isSaving) {
    return
  }

  emit('close')
}
</script>
